import React, { Suspense, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { isLoggedOutTrade } from 'dibs-buyer-layout/exports/isLoggedOutTradeHelper';

const TradeLoggedOutUser = React.lazy(() =>
    import(/* webpackChunkName: "TradeLoggedOutUser" */ './TradeLoggedOutUser')
);

export const TradeLoggedOutUserLoader = () => {
    const [component, setComponent] = useState(null);

    useEffect(() => {
        if (isLoggedOutTrade()) {
            setComponent(
                <Suspense fallback="">
                    <TradeLoggedOutUser />
                </Suspense>
            );
        }
    }, []);

    return component;
};

TradeLoggedOutUserLoader.propTypes = {
    user: PropTypes.object,
};
